(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-hotspots"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lookbook-hotspot')) {
  class LookbookHotspot extends HTMLElement {
    connectedCallback() {
      this.pin = this.querySelector('[data-hotspot-pin]');
      this.card = this.querySelector('[data-hotspot-card]');
      this.closeBtn = this.querySelector('[data-hotspot-close]');
      this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.dockQuery = window.matchMedia('(max-width: 749px), (hover: none)');
      this.dock = this.closest('.lookbook-hotspots')?.querySelector('[data-hotspot-dock]') || null;
      this.docked = false;
      this.suppressFocusOpen = false;
      this.closeTimer = 0;

      this.onPointerEnter = () => {
        this.cancelClose();
        if (this.hoverCapable) this.open();
      };

      this.onPointerLeave = () => {
        if (this.hoverCapable) this.scheduleClose();
      };

      this.onPinClick = (event) => {
        if (this.hoverCapable && event.detail !== 0) return;
        event.preventDefault();
        if (this.classList.contains('is-open')) {
          this.close(true);
          return;
        }
        this.open();
        this.card.focus();
      };

      this.onCloseClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
      };

      this.onFocusIn = () => {
        if (!this.hoverCapable || this.suppressFocusOpen) return;
        this.open();
      };

      this.onFocusOut = (event) => {
        if (this.owns(event.relatedTarget)) return;
        this.scheduleClose();
      };

      this.onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;
        event.stopPropagation();
        this.close(true);
      };

      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keydown', this.onKeydown);
      this.pin.addEventListener('click', this.onPinClick);
      this.closeBtn?.addEventListener('click', this.onCloseClick);
      // The card may be docked outside this element, so it carries its own listeners.
      this.card?.addEventListener('focusout', this.onFocusOut);
      this.card?.addEventListener('keydown', this.onKeydown);
    }

    owns(node) {
      return node instanceof Node && (this.contains(node) || Boolean(this.card?.contains(node)));
    }

    dockCard() {
      if (!this.card || !this.dock || !this.dockQuery.matches) return;
      this.dock.appendChild(this.card);
      this.docked = true;
    }

    undockCard() {
      if (!this.docked || !this.card) return;
      this.appendChild(this.card);
      this.docked = false;
    }

    disconnectedCallback() {
      this.cancelClose();
    }

    open() {
      if (!this.card || this.classList.contains('is-open')) return;
      document.querySelectorAll('lookbook-hotspot.is-open').forEach((node) => {
        if (node !== this) node.close(false);
      });
      this.dockCard();
      this.card.hidden = false;
      this.classList.add('is-open');
      this.pin.setAttribute('aria-expanded', 'true');
    }

    close(restoreFocus) {
      this.cancelClose();
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.pin.setAttribute('aria-expanded', 'false');
      this.card.hidden = true;
      this.undockCard();
      if (restoreFocus) {
        this.suppressFocusOpen = true;
        this.pin.focus();
        this.suppressFocusOpen = false;
      }
    }

    scheduleClose() {
      this.cancelClose();
      this.closeTimer = window.setTimeout(() => {
        if (this.matches(':hover') || this.matches(':focus-within') || this.card?.matches(':focus-within')) return;
        this.close(false);
      }, 180);
    }

    cancelClose() {
      if (!this.closeTimer) return;
      window.clearTimeout(this.closeTimer);
      this.closeTimer = 0;
    }
  }

  customElements.define('lookbook-hotspot', LookbookHotspot);

  document.addEventListener('pointerdown', (event) => {
    const target = event.target;
    document.querySelectorAll('lookbook-hotspot.is-open').forEach((node) => {
      if (!node.owns(target)) node.close(false);
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
